import Sellers from "./Sellers"

export default Sellers;